import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {UcaNavigationService} from "../../services/uca-navigation.service";
import {ParamService} from "../../services/param.service";
import {GameService} from "../../services/game/game.service";



declare var $: any;


@Component({
    selector: 'left-navigation',
    templateUrl: './left-navigation.component.html',
    styleUrls: ['./left-navigation.component.scss']
})
export class LeftNavigationComponent implements OnInit {
    KEYCODE_TAB: number = 9;
    leftNavOptions: any;
    leftNavOptionsList = [];
    banner: any;
    displayBanner: any;
    currentEnvironment: any;

    constructor(private hostElement: ElementRef, private ucaNavigationService: UcaNavigationService,
                private paramService: ParamService, private gameService: GameService) {
    }

    ngOnInit() {
        this.banner = this.paramService.banner;
        this.displayBanner = this.paramService.displayBanner;
        this.currentEnvironment = this.gameService.getEnvironment();
        this.initSubscribes();
        if(this.leftNavOptionsList.length === 0) {
            this.ucaNavigationService.getLeftNavItems(this.banner, this.currentEnvironment);
        }
    }

    initSubscribes() {
        this.ucaNavigationService.populateUcaNavigationSource$.subscribe((value) => {
            if (value && value.root && value.root.responsivegrid && value.root.responsivegrid.left_navigation.staticMenuItems) {
                for (const key in value.root.responsivegrid.left_navigation.staticMenuItems) {
                    value.root.responsivegrid.left_navigation.staticMenuItems[key].menuLink = value.root.responsivegrid.left_navigation.staticMenuItems[key].menuLink.replace(/\(banner\)/g, this.banner);
                    if (value.root.responsivegrid.left_navigation.staticMenuItems[key].menuLink.indexOf('games') >= 0) {
                        value.root.responsivegrid.left_navigation.staticMenuItems[key].menuLink = '/games/game-grid';
                    }

                    this.leftNavOptionsList.push(value.root.responsivegrid.left_navigation.staticMenuItems[key]);
                }
                this.leftNavOptions = value.root.responsivegrid.left_navigation;
                this.leftNavOptions.titleText = this.leftNavOptions.titleText.replace(/\(banner4U\)/g, this.displayBanner);
            }

        });
    }

    @HostListener("keydown", ["$event"])
    onKeyDown(e: KeyboardEvent): any {
        if (window.innerWidth <= 990) {
            if (e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB) {
                let focusableEls = this.hostElement.nativeElement;
                let modalContent = $(focusableEls).find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), input[type="ul"]:not([disabled]), input[type="li"]:not([disabled])');
                var firstFocusableEl = modalContent.first()[0];
                var lastFocusableEl = modalContent.last()[0];

                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus();
                        e.preventDefault();
                    }
                }
            }
        }
    }

}
